module.exports = __webpack_public_path__ + "img/left_icon.1825e8e0.png";